/* globals Debug, MergeQueryStringParameters, HASH_ALL_SCOS */

/* eslint-disable camelcase, new-cap */
function ActivityRepository () {
    this.ActivityList = [];
    this.ActivityTree = null;
    this.ActivityListByIdentifier = [];

    // list of activities sorted in a pre-order traversal...the likely order for flow delivery
    this.SortedActivityList = [];
}

/* eslint-disable no-use-before-define */
ActivityRepository.prototype = {
    InitializeFromRegistration: ActivityRepository_InitializeFromRegistration,
    BuildActivity: ActivityRepository_BuildActivity,
    GetActivityByDatabaseId: ActivityRepository_GetActivityByDatabaseId,
    PreOrderTraversal: ActivityRepository_PreOrderTraversal,
    GetSortedIndexOfActivity: ActivityRepository_GetSortedIndexOfActivity,
    Clone: ActivityRepository_Clone,
    TearDown: ActivityRepository_TearDown,
    SetSequencer: ActivityRepository_SetSequencer,
    GetActivityPath: ActivityRepository_GetActivityPath,
    GetRootActivity: ActivityRepository_GetRootActivity,
    DoesActivityExist: ActivityRepository_DoesActivityExist,
    GetActivityFromIdentifier: ActivityRepository_GetActivityFromIdentifier,
    GetParentActivity: ActivityRepository_GetParentActivity,
    GetNumDeliverableActivities: ActivityRepository_GetNumDeliverableActivities
};
/* eslint-enable no-use-before-define */

function ActivityRepository_InitializeFromRegistration (registration, queryStringAdditions) {
    //
    // Fully populate the activities by associating them with appropriate learning objects
    // and establishing the hierarchy based on the learning object hierarchy
    //
    var globalAddition,
        addition = "",
        i = 0,
        specificAddition;

    // The activity list is simply the list of all activities from the registration
    this.ActivityList = registration.Activities;

    // Establish the Activity Tree by traversing down the learning object tree,
    // finding and populating each associated activity
    this.ActivityTree = this.BuildActivity(registration, registration.Package.LearningObjects[0], null, 1);

    this.PreOrderTraversal(this.ActivityTree, this.SortedActivityList);

    // add in the querystring override parameters if necessary
    globalAddition = queryStringAdditions[HASH_ALL_SCOS];
    for (i = 0; i < this.ActivityList.length; i += 1) {
        addition = "";
        specificAddition = queryStringAdditions[this.ActivityList[i].DatabaseId];

        if (typeof specificAddition !== "undefined" && specificAddition !== null) {
            addition = specificAddition;
        }
        else if (typeof globalAddition !== "undefined" && globalAddition !== null) {
            addition = globalAddition;
        }

        if (addition !== "") {
            this.ActivityList[i].LearningObject.Parameters = MergeQueryStringParameters(addition, this.ActivityList[i].LearningObject.Parameters);
        }

        this.ActivityListByIdentifier[this.ActivityList[i].GetItemIdentifier()] = this.ActivityList[i];
    }
}

function ActivityRepository_BuildActivity (registration, learningObject, parentActivity, ordinalFromParent) {
    var thisActivity = registration.FindActivityForThisScormObject(learningObject.DatabaseIdentifier),
        activityObjective,
        staticActivityObjectiveDefinition,
        identifier,
        sequencingObjective,
        runTimeObjective,
        i;

    thisActivity.LearningObject = learningObject;
    thisActivity.ParentActivity = parentActivity;

    // an ordinal of 0 indicates that it is not initiated yet. so put it in the default order from the structure
    if (thisActivity.Ordinal === 0) {
        thisActivity.Ordinal = ordinalFromParent;
    }

    // initialize all of the static data for the activity objectives
    // eslint-disable-next-line guard-for-in
    for (activityObjective in thisActivity.ActivityObjectives) {
        // get the static definition if it exists
        staticActivityObjectiveDefinition = null;

        for (sequencingObjective in learningObject.SequencingData.Objectives) {
            if (learningObject.SequencingData.Objectives[sequencingObjective].Id === thisActivity.ActivityObjectives[activityObjective].Identifier) {
                staticActivityObjectiveDefinition = learningObject.SequencingData.Objectives[sequencingObjective];
                break;
            }
        }

        if (staticActivityObjectiveDefinition === null) {
            if (learningObject.SequencingData.PrimaryObjective !== null
                && learningObject.SequencingData.PrimaryObjective.Id === thisActivity.ActivityObjectives[activityObjective].Identifier
            ) {
                staticActivityObjectiveDefinition = learningObject.SequencingData.PrimaryObjective;
            }
        }

        // transfer the static data to the object
        if (staticActivityObjectiveDefinition !== null) {
            thisActivity.ActivityObjectives[activityObjective].SatisfiedByMeasure = staticActivityObjectiveDefinition.SatisfiedByMeasure;
            thisActivity.ActivityObjectives[activityObjective].MinNormalizedMeasure = staticActivityObjectiveDefinition.MinNormalizedMeasure;
            thisActivity.ActivityObjectives[activityObjective].Maps = staticActivityObjectiveDefinition.Maps;
        }

        // create a runtime objective for this identifier if needed
        identifier = thisActivity.ActivityObjectives[activityObjective].GetIdentifier();

        // if there is an identifier, then the runtime needs access to its latest state
        if (thisActivity.RunTime !== null
            && typeof identifier !== "undefined"
            && identifier !== null
            && identifier.length > 0
        ) {
            runTimeObjective = thisActivity.RunTime.FindObjectiveWithId(identifier);

            if (runTimeObjective === null) {
                thisActivity.RunTime.AddObjective();

                runTimeObjective = thisActivity.RunTime.Objectives[thisActivity.RunTime.Objectives.length - 1];
                runTimeObjective.Identifier = identifier;
            }
        }
    }

    for (i = 0; i < learningObject.Children.length; i += 1) {
        thisActivity.ChildActivities[i] = this.BuildActivity(
            registration,
            learningObject.Children[i],
            thisActivity,
            i + 1
        );
    }

    thisActivity.StringIdentifier = thisActivity.toString();

    return thisActivity;
}

function ActivityRepository_GetActivityByDatabaseId (databaseId) {
    var i;

    if (databaseId === null) {
        return null;
    }

    for (i = 0; i < this.ActivityList.length; i += 1) {
        if (this.ActivityList[i].DatabaseId === databaseId) {
            return this.ActivityList[i];
        }
    }

    Debug.AssertError("Searched for an activity by database id that did not exist.");

    return null;
}

function ActivityRepository_PreOrderTraversal (activity, activityArray) {
    var i;

    activityArray[activityArray.length] = activity;

    for (i = 0; i < activity.ChildActivities.length; i += 1) {
        this.PreOrderTraversal(activity.ChildActivities[i], activityArray);
    }
}

function ActivityRepository_GetSortedIndexOfActivity (activity) {
    var i;

    for (i = 0; i < this.SortedActivityList.length; i += 1) {
        if (this.SortedActivityList[i] === activity) {
            return i;
        }
    }

    Debug.AssertError("Activity not found in sorted list of activities");

    return null;
}

function ActivityRepository_Clone () {
    var repository = new ActivityRepository(),
        clonedActivity,
        originalActivity,
        activityIndex,
        childActivity,
        availableChildActivity;

    // make a copy of all the activities
    for (activityIndex = 0; activityIndex < this.ActivityList.length; activityIndex += 1) {
        clonedActivity = this.ActivityList[activityIndex].Clone();

        repository.ActivityList[activityIndex] = clonedActivity;
        repository.ActivityListByIdentifier[clonedActivity.GetItemIdentifier()] = clonedActivity;

        if (this.ActivityList[activityIndex].ParentActivity === null) {
            repository.ActivityTree = repository.ActivityList[activityIndex];
        }
    }

    // now that we have copies, set the pointers to the parents and children
    for (activityIndex = 0; activityIndex < this.ActivityList.length; activityIndex += 1) {
        originalActivity = this.ActivityList[activityIndex];
        clonedActivity = repository.ActivityList[activityIndex];

        if (originalActivity.ParentActivity === null) {
            clonedActivity.ParentActivity = null;
        }
        else {
            clonedActivity.ParentActivity = repository.GetActivityFromIdentifier(originalActivity.ParentActivity.GetItemIdentifier());
        }

        for (childActivity in originalActivity.ChildActivities) {
            if (originalActivity.ChildActivities.hasOwnProperty(childActivity)) {
                clonedActivity.ChildActivities[childActivity] = repository.GetActivityFromIdentifier(originalActivity.ChildActivities[childActivity].GetItemIdentifier());
            }
        }

        clonedActivity.AvailableChildren = [];
        for (availableChildActivity in originalActivity.AvailableChildren) {
            if (originalActivity.AvailableChildren.hasOwnProperty(availableChildActivity)) {
                clonedActivity.AvailableChildren[availableChildActivity] = repository.GetActivityFromIdentifier(originalActivity.AvailableChildren[availableChildActivity].GetItemIdentifier());
            }
        }
    }

    repository.PreOrderTraversal(repository.ActivityTree, repository.SortedActivityList);

    return repository;
}

function ActivityRepository_TearDown () {
    // clear out all the references in the activities, especially to the sequencer to avoid memory leaks associated with circular references in JavaScript
    var activityIndex;

    for (activityIndex in this.ActivityList) {
        if (this.ActivityList.hasOwnProperty(activityIndex)) {
            this.ActivityList[activityIndex].TearDown();
            this.ActivityList[activityIndex] = null;
        }
    }

    this.ActivityList = null;
    this.ActivityTree = null;
    this.SortedActivityList = null;
}

function ActivityRepository_SetSequencer (sequencer, isLookAhead) {
    var activity;

    for (activity in this.ActivityList) {
        if (this.ActivityList.hasOwnProperty(activity)) {
            this.ActivityList[activity].SetSequencer(sequencer, isLookAhead);
        }
    }
}

function ActivityRepository_GetActivityPath (activity, includeActivity) {
    var aryParentActivities = [],
        index = 0;

    if (includeActivity) {
        aryParentActivities[index] = activity;
        index += 1;
    }

    while (activity.ParentActivity !== null) {
        activity = activity.ParentActivity;

        aryParentActivities[index] = activity;

        index += 1;
    }

    return aryParentActivities;
}

function ActivityRepository_GetRootActivity () {
    // TODO: optimization, can we just return this.ActivityTree?
    var rootActivity = null,
        i;

    for (i = 0; i < this.SortedActivityList.length; i += 1) {
        if (this.SortedActivityList[i].ParentActivity === null) {
            rootActivity = this.SortedActivityList[i];
            break;
        }
    }

    return rootActivity;
}

function ActivityRepository_DoesActivityExist (identifier) {
    /* eliminated for performance improvement 6-21-05 - MR
    for (var i = 0; i < this.ActivityList.length; i += 1) {
        if (this.ActivityList[i].GetItemIdentifier() == identifier) {
            return true;
        }
    }
    */

    if (this.ActivityListByIdentifier[identifier] !== "undefined" && this.ActivityListByIdentifier[identifier] !== null) {
        return true;
    }

    return false;
}

function ActivityRepository_GetActivityFromIdentifier (identifier) {
    /* eliminated for performance improvement 6-21-05 - MR
    for (var i = 0; i < this.ActivityList.length; i += 1) {
        if (this.ActivityList[i].GetItemIdentifier() == identifier) {
            return this.ActivityList[i];
        }
    }
    */
    if (typeof this.ActivityListByIdentifier[identifier] !== "undefined" && this.ActivityListByIdentifier[identifier] !== null) {
        return this.ActivityListByIdentifier[identifier];
    }

    // MR 6/12/06 - Can't assert an error here because there is a valid case for not finding an activity during a
    // SCO's call to adl.nav.request
    // Debug.AssertError("Could not find activity for identifier " + identifier);

    return null;
}

function ActivityRepository_GetParentActivity (activity) {
    var parentActivity = null;

    if (activity !== null) {
        parentActivity = activity.ParentActivity;
    }

    return parentActivity;
}

function ActivityRepository_GetNumDeliverableActivities () {
    var numDeliverable = 0,
        i;

    for (i = 0; i < this.ActivityList.length; i += 1) {
        if (this.ActivityList[i].IsDeliverable()) {
            numDeliverable += 1;
        }
    }

    return numDeliverable;
}
